/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Component, OnInit, inject } from '@angular/core';
import {NotificationDataService} from "../../services/notification-data.service";
import {Observable} from "rxjs";
import {DisplayNotificationUiPanelService} from "../../services/display-notification-ui-panel.service";
import {NotificationUiPanelComponent} from "../notification-ui-panel/notification-ui-panel.component";
import {UserContext} from '@irian-ro/util-user';

@Component({
    selector: 'irian-ro-mpm-notification-ui-button, mpm-notification-ui-button',
    templateUrl: './notification-ui-button.component.html',
    styleUrls: ['./notification-ui-button.component.scss'],
    standalone: false
})
export class NotificationUiButtonComponent implements OnInit {
  private notificationDataService = inject(NotificationDataService);
  private displayNotificationUiPanelService = inject(DisplayNotificationUiPanelService);
  private userContext = inject(UserContext);


  firstRender = true;

  count: Observable<string> | undefined = undefined;

  displayButton: boolean | undefined = undefined;

  notificationPanelClickState = true;

  ngOnInit(): void {
    this.count = this.notificationDataService.getNotificationCount();

    this.userContext.getCurrentUser().subscribe(
      (user: any) => {
        if (user.uuid && this.firstRender === true) {
          this.displayButton = true;
        } else if (!user.uuid) {
          this.displayButton = false;
          this.firstRender === false;
        }
      });
  }

  handleClick() {
    this.notificationPanelClickState = this.displayNotificationUiPanelService.getNotificationPanelClickState();

    if (this.displayNotificationUiPanelService && this.notificationPanelClickState) {
      this.displayNotificationUiPanelService.insertSadComponent(NotificationUiPanelComponent);
    } else if (!this.notificationPanelClickState) {
      this.displayNotificationUiPanelService.reset();
    } else {
      throw new Error('Provide a DisplayNotificationUiPanelService instance');
    }
  }

}
